import { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useMember } from "@/contexts/MemberAuthContext";

export default function MemberLogin() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const { login, member } = useMember();
  const nav = useNavigate();
  const loc = useLocation();
  const from = loc.state?.from || "/account";

  useEffect(() => { if (member) nav(from); }, [member, nav, from]);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await login(form.email, form.password);
      nav(from);
    } catch (e) {
      setErr(e.response?.data?.detail || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#050505] pt-28 pb-16 flex items-center">
      <div className="max-w-md mx-auto px-6 w-full">
        <div className="text-center mb-8">
          <p className="text-[10px] tracking-[0.4em] text-[#D4AF37] mb-2">MEMBER ACCESS</p>
          <h1 className="font-heading text-3xl text-white tracking-wider">Welcome Back</h1>
        </div>

        <div className="bg-[#0A0A0A] border border-white/5 rounded-lg p-8">
          <form onSubmit={submit} className="space-y-4">
            <input
              required autoComplete="email" data-testid="member-login-email"
              type="email" placeholder="Email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="w-full bg-black border border-white/10 focus:border-[#D4AF37] px-4 py-3 text-white text-sm outline-none rounded"
            />
            <input
              required autoComplete="current-password" data-testid="member-login-password"
              type="password" placeholder="Password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="w-full bg-black border border-white/10 focus:border-[#D4AF37] px-4 py-3 text-white text-sm outline-none rounded"
            />

            {err && <p className="text-red-400 text-xs" data-testid="member-login-error">{err}</p>}

            <button
              disabled={busy}
              data-testid="member-login-submit"
              className="w-full py-3 bg-[#D4AF37] text-black text-xs uppercase tracking-widest font-bold hover:bg-white transition-colors disabled:opacity-40"
            >
              {busy ? "Signing in..." : "Sign In"}
            </button>
          </form>

          <div className="mt-6 pt-6 border-t border-white/5 text-center text-xs text-white/40 space-y-2">
            <div>No account? <Link to="/join" className="text-[#D4AF37] hover:text-white" data-testid="member-join-link">Join Now</Link></div>
            <div className="text-white/20 text-[10px] uppercase tracking-widest">Admin? <Link to="/admin/login" className="hover:text-[#D4AF37]" data-testid="admin-login-link">Enter Panel</Link></div>
          </div>
        </div>
      </div>
    </div>
  );
}
